export default "__VITE_ASSET__D0wVxfJE__"